<template>
  <div class="limiter">
    <div class="container-login100">
      <div class="scan">
        <h1>QR Code Scanner</h1>
        <qriously :value="qrCodeData" size="200" level="H"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScanPage',
  data() {
    return {
      testId: '4', // Set your test ID here
      testUrl: 'http://192.168.1.44:8080/login'
    };
  },
  computed: {
    qrCodeData() {
      return `${this.testUrl}?id=${this.testId}`;
    }
  }
};
</script>
